import { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import FileUpload from "../../../../../../parts/inputs/file-upload";
import ImageWidgetUploadInput from "../../../../../../parts/inputs/image-widget-upload";

export const EditFile = ({
  nameProps,
  descriptionProps,
  fileProps,
  _idProps,
  widgetProps,
  imageProps,
  widgetType,
}) => {
  const [editState, setEditState] = useState({
    //state to control the file's edit form
    name: nameProps,
    file: fileProps,
    description: descriptionProps,
    widget: widgetProps,
    _id: _idProps,
    image: imageProps,
  });

  const handleEditInputChange = ({ target }) => {
    const newState = Object.assign({}, editState, {
      [target.name]: target.value,
    });
    setEditState(newState);
  };

  /**
   * Validate if edit form is valid
   * @returns
   */
  const validationFileSubmit = () => {
    if (editState.name.length > 0 && editState.description.length > 0) {
      return true;
    }
    return false;
  };

  const { t } = useTranslation("coaching-portal");

  return (
    <form
      encType="multipart/form-data"
      method="POST"
      data-noreset
      action={`/actions/${widgetType}/save/${_idProps}`}
      className="add-edit-file-wraper"
    >
      <div>
        <FileUpload name="file" prefix="" defaultValue={fileProps} />

        <ImageWidgetUploadInput
          name="image"
          prefix=""
          defaultValue={editState.image}
          backgroundedit={`${editState.image?.s3Path || ""}`}
          hasImage={true}
        />
      </div>
      <div>
        <div>
          <div className="input-box">
            <label> {t("widgets.editFile.fileName")} </label>
            <input
              name="name"
              className="input-videoplaylist-name text-input"
              placeholder={t("widgets.editFile.enterFileName")}
              value={editState.name}
              onChange={handleEditInputChange}
            />
          </div>
          <div className="input-box">
            <label> {t("widgets.editFile.description")} </label>
            <input
              name="description"
              className="input-videoplaylist-name text-input"
              value={editState.description}
              onChange={handleEditInputChange}
              placeholder={t("widgets.editFile.enterDescription")}
            />
          </div>
        </div>
        <input
          name="widget"
          style={{ display: "none" }}
          defaultValue={editState.widget}
        />
        <button
          className={
            validationFileSubmit()
              ? "save-macro-btn"
              : "save-macro-disabled-btn save-macro-btn"
          }
          data-button-type="primary"
          disabled={!validationFileSubmit()}
        >
          {t("widgets.common.save")}
        </button>
      </div>
    </form>
  );
};

EditFile.propTypes = {
  nameProps: PropTypes.string,
  descriptionProps: PropTypes.string,
  fileProps: PropTypes.object,
  _idProps: PropTypes.string,
  widgetProps: PropTypes.string,
  imageProps: PropTypes.any,
  widgetType: PropTypes.string,
};
